import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

function ContactForm() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        'https://berisdesignatelier.com/api/auth/contact',
        formData
      );

      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Thank You for Contacting Us!',
          text: 'Our team will connect with you shortly to assist you.',
        });

        // Reset form data
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred while sending data. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    const charCode = event.charCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };

  return (
    <section className="tc-contact-form-style1">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-4">
            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
              <h3 className="fsz-45 fw-500 mb-80">
                Let us help build your dream!
              </h3>
              <p className="fsz-14 color-666 mt-15">
                {/* Your email address will not be published. <br /> Required fields
                are marked <span className="text-danger"> * </span> */}
                Your email address or phone number will not be published.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <form
            onSubmit={onSubmit}
              action=""
              className="form mt-5 mt-lg-0 wow fadeInUp slow"
              data-wow-delay="0.4s"
            >
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="">
                      Full name <span className="color-orange1"> * </span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Your name"
                      onChange={handleInputChange}
                      value={formData.name}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="">
                      email address <span className="color-orange1">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="Your email address"
                      onChange={handleInputChange}
                      value={formData.email}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="">
                      Phone <span className="color-orange1">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="phone"
                      name="phone"
                      placeholder="Your phone number"
                      onChange={handleInputChange}
                      value={formData.phone}
                      onKeyPress={handleKeyPress}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                <div className="form-group mb-30">
  <label htmlFor="">
    Subject <span className="color-orange1"> * </span>
  </label>
  <select name="subject" 
  value={formData.subject}
  onChange={handleInputChange}
  className="form-select form-control"
  required
   >
    <option value="">Select a subject</option>
    <optgroup label="Architecture Design">
      <option value="Homes">Homes Design</option>
      <option value="Commercial Design">Commercial Design</option>
      <option value="Interior Design">Interior Design</option>
    </optgroup>
    <optgroup label="Interior Design">
      <option value="Residencial Design">Subject 1.1</option>
      <option value="commercial design">Subject 1.2</option>
      <option value="1.3">Subject 1.3</option>
    </optgroup>
    <optgroup label="Planning">
      <option value="1.1">Subject 1.1</option>
      <option value="1.2">Subject 1.2</option>
      <option value="1.3">Subject 1.3</option>
    </optgroup>
  </select>
</div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group mb-30">
                    <label htmlFor=""> message <span className="color-999"> (optional) </span> </label>
                    <textarea
                      rows="6"
                      id="message"
                      name="message"
                      placeholder="Write your message here"
                      className="form-control"
                      onChange={handleInputChange}
                      value={formData.message}
                    ></textarea>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                id="submit"
                className="butn hover-bg-orange1 text-capitalize bg-white rounded-pill mt-40"
              >
                <span>{loading ? 'Sending...' : 'Send Message'}</span>
              </button>
              <p className="fsz-12 color-666 mt-20">
              By submitting, I agree to the <span className='ms-1'></span> 
                <a href="/Termconditions" className="color-000 text-decoration-underline">
                   Terms & Conditions 
                </a>
              </p>
            </form>
          </div>
        </div>
      </div>
      <img
        src="/innerpages/assets/img/contact_shap.png"
        alt=""
        className="shap"
      />
    </section>
  );
}

export default ContactForm;
